// @flow
import * as React from 'react';
import styled from 'styled-components';
import * as _ from "lodash";
import BlankPlayer from '../../assets/images/BlankPlayer.png';
import { BenchTitle, TableFlexBody } from '../';
import { below } from '../../assets/css/media';

const EmptyTeamTableStyled = styled.div`
	background: #fff;
	width: 100%;
	opacity: .36;
	header {
		height: 50px;
		width: 100%;
	}
`;
const EmptyStatsHeader = styled.div`
	height: 50px;
	width: 100%;
	background: #ECECEC;
`;
const TableRowStyled = styled.div`
	height: 61px;
	border-bottom: 1px solid transparent;
	${below.desktop`
		height: 50px;
	`}
	img {
		margin-left: 20px;
		height: 100%;
	}
`;

const TableRow = () => (
	<TableRowStyled>
		<img src={BlankPlayer} alt="player" />
	</TableRowStyled>
);
export const EmptyTeamTable = ({ empty_lineup }: Object) => {
	const lineup_pure = _.omit(empty_lineup, ['captain', 'vice_captain', 'bench', 'emergency']);
	const bench = _.get(empty_lineup, 'bench');

	return (
		<EmptyTeamTableStyled>
			<header />
			<EmptyStatsHeader />
			<TableFlexBody>
				{_.map(lineup_pure, line => line.map(() => (
					<TableRow key={_.uniqueId()} />
				)))}
				<BenchTitle>
					Bench
				</BenchTitle>
				{_.map(bench, () => (
					<TableRow key={_.uniqueId()} />
				))}
			</TableFlexBody>
		</EmptyTeamTableStyled>
	);
};

export default EmptyTeamTable;


// WEBPACK FOOTER //
// ./src/components/Team/EmptyTeamTable.js